export default __webpack_public_path__ + "static/media/cerdoahumado.6bacfbc7.jpg";